import React from 'react';
import styled from 'styled-components';

import { LiveStreamingDto } from '@/application/interfaces/pegasus.gateway';

import LivesSlider from '../lives-course-slider/lives-slider';

type Props = {
  lives: LiveStreamingDto[];
};

const Container = styled.header`
  margin-bottom: 3em;
`;

const HeaderContainer = styled.header`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h1`
  padding-top: 1rem;
  padding-bottom: 0.5rem;
  font-size: 32px;
  font-weight: 700;
  line-height: 38px;
  letter-spacing: -1px;
  text-align: left;
`;

const Classifier: React.FC<Props> = ({ lives }) => {
  return (
    <Container>
      <HeaderContainer>
        <Title>Aulas ao vivo</Title>
      </HeaderContainer>

      <LivesSlider lives={lives} />
    </Container>
  );
};

const LiveClassifierItem: React.FC<Props> = ({ lives }) => {
  return lives.length > 0 ? <Classifier lives={lives} /> : null;
};

export default LiveClassifierItem;
